var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1657 7.43441C14.3157 7.58443 14.3999 7.78787 14.3999 8.00001C14.3999 8.21214 14.3157 8.41558 14.1657 8.56561L8.5657 14.1656C8.41568 14.3156 8.21223 14.3998 8.0001 14.3998C7.78797 14.3998 7.58452 14.3156 7.4345 14.1656L1.8345 8.56561C1.7601 8.49141 1.70109 8.40326 1.66087 8.30619C1.62064 8.20913 1.59999 8.10507 1.6001 8.00001V4.00001C1.6001 3.36349 1.85295 2.75304 2.30304 2.30295C2.75313 1.85286 3.36358 1.60001 4.0001 1.60001H8.0001C8.2049 1.60001 8.4097 1.67841 8.5657 1.83441L14.1657 7.43441ZM4.0001 4.80001C4.21227 4.80001 4.41575 4.71572 4.56578 4.56569C4.71581 4.41566 4.8001 4.21218 4.8001 4.00001C4.8001 3.78783 4.71581 3.58435 4.56578 3.43432C4.41575 3.28429 4.21227 3.20001 4.0001 3.20001C3.78792 3.20001 3.58444 3.28429 3.43441 3.43432C3.28438 3.58435 3.2001 3.78783 3.2001 4.00001C3.2001 4.21218 3.28438 4.41566 3.43441 4.56569C3.58444 4.71572 3.78792 4.80001 4.0001 4.80001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.17f0ee5978d049c7c1b9ef49a64eb771.svg";
export { ForwardRef as ReactComponent };